import { defineComponent, ref } from 'vue';
import __vue_component__ from './FilePicker/FilePicker.vue.js';
import __vue_component__$1 from './FileViewer/FileViewer.vue.js';
import '@caresend/types';
import 'file-saver';
import '../../database/firebaseConfig/cloudFunctions.js';
import { DownloadOption } from '../../database/encryption/model.js';
import '@caresend/utils';
import 'js-sha256';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';

var script = defineComponent({
    name: 'FilePickerViewer',
    components: {
        FilePicker: __vue_component__,
        FileViewer: __vue_component__$1,
    },
    props: {
        accessAttributes: {
            type: Array,
            default: undefined,
        },
        customOptions: {
            type: Array,
            default: () => [],
        },
        compress: {
            type: Boolean,
            default: true,
        },
        confirmDelete: Boolean,
        desktopOptions: {
            type: Array,
            default: () => [DownloadOption.OPEN, DownloadOption.DOWNLOAD],
        },
        displaySpacer: {
            type: Boolean,
            default: true,
        },
        downloadLabel: {
            type: String,
            default: 'Download',
        },
        encrypt: Boolean,
        fileTypes: {
            type: String,
            default: 'application/pdf,image/*',
        },
        initialValue: {
            type: [String, Object, Array],
            default: null,
        },
        isMinimalView: Boolean,
        minimalViewStyle: {
            type: String,
            default: 'kebab',
        },
        mobileOptions: {
            type: Array,
            default: () => [DownloadOption.DOWNLOAD],
        },
        multiple: Boolean,
        noDelete: Boolean,
        noOptions: Boolean,
        openLabel: {
            type: String,
            default: 'Open',
        },
        size: {
            type: String,
            default: 'sm',
        },
        path: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Upload a file',
        },
        useOriginalFileName: Boolean,
        isReadOnly: Boolean,
    },
    setup(_props, { emit }) {
        const files = ref([]);
        const handleUpdate = (newValue) => {
            files.value = newValue;
            emit('uploadedFilesUpdated', files.value);
        };
        return {
            handleUpdate,
            files,
        };
    },
});

export { script as default };
